import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../../../../css/index.css";
import SectionGroup from "../SectionGroup/index.js";
import SectionItem from "../SectionItem/index.js";
import { useTKHost } from "../../HostContext.js";
const TheCompanySection = () => {
  const tkHost = useTKHost();
  const items = [{
    children: 'The Knot Worldwide',
    href: 'https://www.theknotww.com/'
  }, {
    children: 'About us',
    href: 'https://www.theknotww.com/about-us/'
  }, {
    children: 'The Knot Editorial',
    href: `${tkHost}/about-editorial`
  }, {
    children: 'Careers',
    href: 'https://www.theknotww.com/careers/'
  }, {
    children: 'International',
    href: 'https://www.theknotww.com/international/'
  }, {
    children: 'Press',
    href: 'https://www.theknotww.com/press-room/'
  }, {
    children: 'National advertising',
    href: 'https://www.theknotww.com/advertising/national/',
    trackableProps: {
      selection: 'advertisers'
    }
  }, {
    children: 'Our sponsors',
    href: 'https://www.theknot.com/partners',
    trackableProps: {
      selection: 'sponsors'
    }
  }];
  return /*#__PURE__*/React.createElement(SectionGroup, {
    title: "The Company",
    trackableProps: {
      selection: 'company'
    },
    className: styles.companySection
  }, _mapInstanceProperty(items).call(items, itemProps => /*#__PURE__*/React.createElement(SectionItem, _extends({
    key: itemProps.href
  }, itemProps))));
};
process.env.NODE_ENV !== "production" ? TheCompanySection.propTypes = {
  tkHost: PropTypes.string
} : void 0;
export default TheCompanySection;